import React from "react";
import { useClient } from "../../context/client-context";

const BottomFooter = () => {
  const client = useClient();
  return (
    <div className="bottom-footer bg-color-one py-8">
      <div className="container container-lg">
        <div className="bottom-footer__inner flex-between flex-wrap gap-16 py-16">
          <p className="bottom-footer__text text-xs">
            {client.name} eCommerce © {new Date().getFullYear()}. All Rights
            Reserved{" "}
          </p>
          <div className="flex-align gap-8 flex-wrap">
            <span className="text-heading text-xs">We Are Acepting</span>
            <img src="/assets/images/icon/mpesa.png" alt="mpesa" width={50} />
            {/* <img src="/assets/images/thumbs/payment-method.png" alt="" /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomFooter;
